module.exports = __webpack_public_path__ + "static/media/octopus-tree.195bec47.png";